var _CUSTOM_COD_FORM_PROVINCES = {
  data: {"CIUDAD DE MÉXICO":{"ÁLVARO OBREGÓN":true,"AZCAPOTZALCO":true,"BENITO JUÁREZ":true,"COYOACÁN":true,"CUAJIMALPA DE MORELOS":true,"CUAUHTÉMOC":true,"GUSTAVO A. MADERO":true,"IZTACALCO":true,"IZTAPALAPA":true,"LA MAGDALENA CONTRERAS":true,"MIGUEL HIDALGO":true,"MILPA ALTA":true,"TLÁHUAC":true,"TLALPAN":true,"VENUSTIANO CARRANZA":true,"XOCHIMILCO":true},"ESTADO DE MÉXICO":{"ALMOLOYA DE JUÁREZ":true,"ATIZAPÁN":true,"ATIZAPÁN DE ZARAGOZA":true,"CALIMAYA":true,"CHALCO":true,"CHICOLOAPAN":true,"CHIMALHUACÁN":true,"COACALCO DE BERRIOZÁBAL":true,"CUAUTITLÁN":true,"CUAUTITLÁN IZCALLI":true,"ECATEPEC DE MORELOS":true,"HUEHUETOCA":true,"HUIXQUILUCAN":true,"IXTAPALUCA":true,"LA PAZ":true,"LERMA":true,"MELCHOR OCAMPO":true,"METEPEC":true,"NAUCALPAN DE JUÁREZ":true,"NEZAHUALCÓYOTL":true,"NICOLÁS ROMERO":true,"SAN ANTONIO DE LA ISLA":true,"SAN MATEO ATENCO":true,"TECÁMAC":true,"TEPOTZOTLÁN":true,"TEXCOCO":true,"TLALNEPANTLA DE BAZ":true,"TOLUCA":true,"TULTEPEC":true,"TULTITLÁN":true,"VALLE DE CHALCO SOLIDARIDAD":true,"ZINACANTEPEC":true,"ZUMPANGO":true},"JALISCO":{"GUADALAJARA":true,"SAN PEDRO TLAQUEPAQUE":true,"TONALA":true,"ZAPOPAN":true}},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var html = "";
    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      return;
    }
    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
  }
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
    var html = "";
    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }
    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";
        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
          html += '<option value="' + item + '">' + item + '</option>';
        });
        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }
    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }
    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [{
        label: _COD_FORM_PROVINCE_LABEL,
        value: "",
      }];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    }
  });
  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }
  return true;
}